import {CPSConstants} from "commonUtils/enumerations";

export const loginFormInputLabelStyle = {
  loginTextLebelMuiStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#242A3C",
    fontWeight: CPSConstants.FONTWEIGHT,
    fontSize: CPSConstants.FONTREMTEXT,
  },
};
